import { Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const NoJobsInManifestWarning = () => {
    return (
        <Space style={{ color: 'var(--error-normal)', marginBottom: 2 }} size={6}>
            <WarningOutlined />
            <span>There are no jobs in this manifest.</span>
        </Space>
    );
};

export default NoJobsInManifestWarning;
